import { defineComponent as _defineComponent } from 'vue'
import { computed, inject, ref, Ref } from 'vue';
import { useRouter } from 'vue-router/composables';

import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import {
  BaseText,
  Row,
  HeadingDisplay,
  ListDisplay,
  SkeletonLoader,
  ButtonContainer,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';
import { RiskSignature } from '@/modules/common/components/RiskSignature';

import {
  IRiskSignature,
  IProductInfoResponse,
  riskProductSignature
} from '@/modules/transaction/services/product-investment';

import { notify } from '@/modules/common/helpers/notification';
import { NotificationTypes } from '@/modules/common/services/http/notification';
import InputQuantity from '@/modules/transaction/components/InputQuantity/InputQuantity.vue';
import InstrumentAvatar from '@/modules/trade/components/InstrumentAvatar/InstrumentAvatar.vue';
import { debounce } from 'lodash-es';
import { isImpersonate } from '@/modules/common/services/partner';


export default /*#__PURE__*/_defineComponent({
  __name: 'InvestmentStep',
  setup(__props) {

const router = useRouter();
const productInfo = inject('productInfo') as Ref<IProductInfoResponse>;
const riskSignatureData = inject('riskSignatureData') as Ref<IRiskSignature>;
const productId = inject('productId') as Ref<string>;
const isFetchingProduct = inject('isFetchingProduct') as Ref<boolean>;
const isFetchingReview = inject('isFetchingReview') as Ref<boolean>;
const productType = inject('productType') as Ref<string>;

const useBaseAssetChoice = inject('useBaseAssetChoice') as Ref<boolean>;

const useBaseAsset = computed(() => {
  return useBaseAssetChoice.value;
});

const fetchInvestmentReview = inject(
  'fetchInvestmentReview',
  (amount: number, useBaseAsset: boolean) => ({
    amount,
    useBaseAsset
  })
);

const fetchProductInfo = inject(
  'fetchProductInfo',
  (productIdParam: string, quantity: number, useBaseAssetParam: boolean) => ({
    productId: productIdParam,
    quantity,
    useBaseAsset: useBaseAssetParam
  })
);

const isRiskSignatureOpen = ref(false);
const isLoading = ref(false);
const updateValue = ref(false);
const isCorrectedValue = ref(false);

const investmentInput = ref(0);

const hasBalance = computed(() => {
  return productInfo.value?.top?.value;
});

const balanceTitle = computed(() => {
  return productInfo.value?.top?.label;
});

const balanceValue = computed(() => {
  return hasBalance.value ? productInfo.value?.top?.value : 'Depositar';
});

const headerValueClass = computed(() => {
  return hasBalance.value ? '' : 'investment-step__header--value';
});

const helperText = computed(() => {
  return productInfo.value?.helper;
});

const status = computed(() => {
  return helperText?.value?.length > 0 ? 'error' : 'default';
});

const details = computed(() => {
  return productInfo.value?.items || [];
});

const shortcuts = computed(() => {
  return productInfo.value?.shortcuts || [];
});

const isDisabled = computed(() => {
  return (
    investmentInput.value <= 0 ||
    status.value === 'error' ||
    isFetchingReview.value ||
    isFetchingProduct.value
  );
});

const onInputChange = debounce(onChangeValue, 500);

function onChangeValue(value: number) {
  if (value > 0) {
    investmentInput.value = value;
    isCorrectedValue.value = false;

    fetchProductInfo(
      productId.value,
      investmentInput.value,
      useBaseAsset.value
    );
  }
}

function investClick() {
  if (riskSignatureData.value.requestRisksSignature.length > 0) {
    isRiskSignatureOpen.value = true;
    return;
  }

  fetchInvestmentReview(investmentInput.value, useBaseAsset.value);
}

async function handleRiskSignature() {
  if (isImpersonate()) {
    router.push({
      name: 'productsCatalog',
      params: {
        type: productType.value
      }
    });
    return;
  }

  isRiskSignatureOpen.value = false;

  try {
    isLoading.value = true;

    await riskProductSignature(productId.value);

    fetchInvestmentReview(investmentInput.value, useBaseAsset.value);
  } catch {
    notify({
      group: 'wrn-notifications',
      text: 'Houve um problema ao aceitar os riscos. Aguarde alguns instantes e tente novamente.',
      type: NotificationTypes.error
    });
  } finally {
    isLoading.value = false;
  }
}

function redirectToDeposit() {
  if (hasBalance.value) return;

  router.push({ name: 'deposit-pix' });
}

return { __sfc: true,router, productInfo, riskSignatureData, productId, isFetchingProduct, isFetchingReview, productType, useBaseAssetChoice, useBaseAsset, fetchInvestmentReview, fetchProductInfo, isRiskSignatureOpen, isLoading, updateValue, isCorrectedValue, investmentInput, hasBalance, balanceTitle, balanceValue, headerValueClass, helperText, status, details, shortcuts, isDisabled, onInputChange, onChangeValue, investClick, handleRiskSignature, redirectToDeposit, NebraskaColors, BaseText, Row, HeadingDisplay, ListDisplay, SkeletonLoader, ButtonContainer, ButtonPrimary, RiskSignature, InputQuantity, InstrumentAvatar }
}

})